import { Row, Col } from 'src/componentes/grid';
import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import PanelCollapse from 'src/componentes/panel-collapse';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';

const CustomFieldsSection = ({ model, intl, searchQuery = '' }) => {
  const customFields = model.getModel('camposCustomizados');

  const fields =
    customFields?.value?.map((field) => ({
      label: field.descricaoCampo,
      id: field.idCampo,
    })) || [];

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;

  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  return (
    customFields?.value?.length > 0 && (
      <PanelCollapse
        header={intl.formatMessage({ id: 'informacoesComplementares' })}
        open={matchCount > 0 && searchQuery !== ''}
        ehAccordionDrawer={true}
      >
        <Row>
          <Col md={12}>
            <DesenharCampoCustomizado
              model={customFields}
              mdFields={12}
              visibleFields={visibleFields}
              useVisibleFields={searchQuery !== ''}
            />
          </Col>
        </Row>
      </PanelCollapse>
    )
  );
};

export default CustomFieldsSection;
